module.exports = __webpack_public_path__ + "static/img/sp-pickup-recruit.110d975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sp-pickup-recruit.png
// module id = 03N+
// module chunks = 1